 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_HALFTITLE_PAGE from '@/components/xhtml/01_Halftitle_Page'
 import XHTML02_SERIES_PAGE from '@/components/xhtml/02_Series_Page'
 import XHTML03_TITLE_PAGE from '@/components/xhtml/03_Title_Page'
 import XHTML04_COPYRIGHT from '@/components/xhtml/04_Copyright'
 import XHTML05_DEDICATION from '@/components/xhtml/05_Dedication'
 import XHTML06_CONTENTS from '@/components/xhtml/06_Contents'
 import XHTML07_FOREWORD from '@/components/xhtml/07_Foreword'
 import XHTML08_ACKNOWLEDGMENTS from '@/components/xhtml/08_Acknowledgments'
 import XHTML09_HALFTITLE_PAGE_1 from '@/components/xhtml/09_Halftitle_Page_1'
 import XHTML10_HISTORIANS_AND_INTELLECTUAL_LIFE from '@/components/xhtml/10_Historians_and_Intellectual_Life'
 import XHTML11_U_S__SANITARY_COMMISSION_PHYSICI from '@/components/xhtml/11_U_S__Sanitary_Commission_Physici'
 import XHTML12_CIVIL_WAR_CYBERNETICS__MEDICINE from '@/components/xhtml/12_Civil_War_Cybernetics__Medicine'
 import XHTML13_TO_SAVE_THE_AFFLICTED_UNION__RAC from '@/components/xhtml/13_To_Save_the_Afflicted_Union__Rac'
 import XHTML14_JOHN_CODMAN_ROPES__A_LAWYER_S_HI from '@/components/xhtml/14_John_Codman_Ropes__A_Lawyer_s_Hi'
 import XHTML15_SAVE_A_SCHOOL_TO_SAVE_A_NATION from '@/components/xhtml/15_Save_a_School_to_Save_a_Nation'
 import XHTML16_LESSONS_OF_WAR__THREE_CIVIL_WAR from '@/components/xhtml/16_Lessons_of_War__Three_Civil_War'
 import XHTML17_THE_REBELS__LAST_DEVICE___THEOD from '@/components/xhtml/17_The_Rebels__Last_Device___Theod'
 import XHTML18_FOR_THEIR_ADOPTED_HOME__NATIVE_N from '@/components/xhtml/18_For_Their_Adopted_Home__Native_N'
 import XHTML19_THOMAS_F__MEAGHER__PATRICK_R__GU from '@/components/xhtml/19_Thomas_F__Meagher__Patrick_R__Gu'
 import XHTML20_THIS_MOST_UNHOLY_AND_DESTRUCTIV from '@/components/xhtml/20_This_Most_Unholy_and_Destructiv'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML21_NOTES from '@/components/xhtml/21_Notes'
 import XHTML22_LIST_OF_CONTRIBUTORS from '@/components/xhtml/22_List_of_Contributors'
 import XHTML23_INDEX from '@/components/xhtml/23_Index'
 import XHTML24_SERIES_LIST from '@/components/xhtml/24_Series_List'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/06_Contents",
 			"name" : "xhtml/06_Contents",
 			"component" : XHTML06_CONTENTS
 		},
 		{
 			"path" : "/xhtml/07_Foreword",
 			"name" : "xhtml/07_Foreword",
 			"component" : XHTML07_FOREWORD
 		},
 		{
 			"path" : "/xhtml/08_Acknowledgments",
 			"name" : "xhtml/08_Acknowledgments",
 			"component" : XHTML08_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/09_Halftitle_Page_1",
 			"name" : "xhtml/09_Halftitle_Page_1",
 			"component" : XHTML09_HALFTITLE_PAGE_1
 		},
 		{
 			"path" : "/xhtml/10_Historians_and_Intellectual_Life",
 			"name" : "xhtml/10_Historians_and_Intellectual_Life",
 			"component" : XHTML10_HISTORIANS_AND_INTELLECTUAL_LIFE
 		},
 		{
 			"path" : "/xhtml/11_U_S__Sanitary_Commission_Physici",
 			"name" : "xhtml/11_U_S__Sanitary_Commission_Physici",
 			"component" : XHTML11_U_S__SANITARY_COMMISSION_PHYSICI
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js